import { Image } from 'utils'
import { action, clear_action, live } from 'actions'

export default function( space, container, spec, slot, presenter )
{
    const lines = []
    for ( let li = 0; li < spec.specification.linesCountMax; ++ li )
    {
        const l = Image( slot.lines_pattern.$( li ) )
        l.position.set( slot.lines_position[ li ][ 0 ], slot.lines_position[ li ][ 1 ] )
        l.visible = false
        container.addChild( l )
        lines.push( l )
    }

    let linesGroupSounds = [];
    if (slot.lines_sound_pattern) {
        for (let i = 0; i < spec.lines_array.length; ++i) {
            linesGroupSounds.push(sounds.get(slot.lines_sound_pattern + i));
        }
    }
    
    
    const a = action()
    
    space.s( 'presenter:lines:show' ).on( ({ line, visibility }) => {
        const l = lines[ line ]
        l.visible = true
        if ( visibility ) console.log( 'LINE VISIBILITY', visibility )
    } )
    space.s( 'presenter:lines:hide' ).on( ({ line }) => {
        lines[ line ].visible = false
    } )
    
    space.s( 'slot:linesChange' ).on( change => {
        clear_action( a )
        
        for ( let li = 0; li < lines.length; ++ li )
        {
            const l = lines[ li ]
            l.alpha = 1
            l.visible = li < change[ 1 ]
        }
        
        //hide later:
        a.push({ duration : 1.700 })
        const HIDE_IN = 0.460
        a.push({ duration : HIDE_IN, callback : k => {
            for ( const l of lines ) l.alpha = 1.0 - ( k / HIDE_IN )
        }})
        
        //billets:
        for ( let i = 0; i < change[ 1 ]; ++ i ) presenter.fadeInActiveBillets( i )
        for ( let i = change[ 1 ]; i < spec.specification.linesCountMax; ++ i ) presenter.fadeOutActiveBillets( i )

        let soundId = spec.lines_array.indexOf(change[ 1 ]);
        if (linesGroupSounds && soundId >= 0) {
            linesGroupSounds[soundId].play();
        }
    } )
    
    space.s( 'slot:spinStart' ).on( () => {
        clear_action( a )
        for ( const l of lines ) l.visible = false
    } )
    
    space.s( 'presenter:play_line' )
        .with( space.s( 'math' ), ( lo, math ) => ({ l : math.winLines()[ lo ], math }) )
        .on( ({ l, math }) => {
            clear_action( a )
            for ( const li in lines )
            {
                const line = lines[ li ]
                if ( li == l )
                {
                    line.visible = true
                    line.alpha = 1
                }
                else
                {
                    line.visible = false
                }
            }
        } )
    
    space.s( 'ticker' ).on( s => live( a, s ) )
}






// WEBPACK FOOTER //
// ./src/games/lines.es6